import React from 'react'
import {useDispatch} from 'react-redux'
import {
  ContentArea,
  PageHeader,
  // PageTitle,
  PageWrapper,
} from './ProposalMain.styles'
import {Outlet} from 'react-router'
import {ProposalHeader} from '../components/ProposalHeader'
import {resetAll} from '../../../app-store/ProposalSlice'

export function ProposalMain() {
  const dispatch = useDispatch()

  React.useEffect(() => {
    return () => {
      dispatch(resetAll())
    }
  }, [dispatch])

  return (
    <PageWrapper data-theme="ooe-v1">
      <PageHeader>
        <ProposalHeader />
      </PageHeader>
      <ContentArea>
        <Outlet />
      </ContentArea>
    </PageWrapper>
  )
}
